// @flow

import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import CustomEvent from 'custom-event';
import Html from 'Html';
import ScalableMedia from 'ScalableMedia';
import StorylinePagination from 'StorylinePagination';

class Story extends PureComponent {
  static defaultProps = {
    entityLabel: '',
    // fieldMetaTags: '',
    title: '',
    body: '',
    fieldImage: '',
    fieldImage2: '',
    fieldSubtitle: '',
    fieldThemeColor: '',
    fieldShortDescription: '',
  };

  static propTypes = {
    entityLabel: PropTypes.string.isRequired,
    // fieldMetaTags: PropTypes.string,
    title: PropTypes.string.isRequired,
    body: PropTypes.string,
    fieldImage: PropTypes.string.isRequired,
    fieldImage2: PropTypes.string.isRequired,
    fieldSubtitle: PropTypes.string.isRequired,
    fieldThemeColor: PropTypes.string.isRequired,
    fieldShortDescription: PropTypes.string,
  };

  componentDidMount() {
    global.dispatchEvent(new CustomEvent('runKineticAnimations'));
  }

  componentDidUpdate() {
    global.dispatchEvent(new CustomEvent('runKineticAnimations'));
  }

  /* eslint-disable react/no-danger */
  render() {
    return (
      <main
        className={`site-content theme--${this.props
          .fieldThemeColor} animate--fade-in-default`}
      >
        <Helmet title={this.props.entityLabel}>
          <meta
            property="og:title"
            content={`${this.props.entityLabel} | Ferguson Voices`}
          />
        </Helmet>
        <div className="site-content__teaser centered title-teaser">
          <div className="title-teaser__svg svg-wrapper svg-wrapper--left-double-quote js-kinetic-animation hide-on-mobile">
            <svg aria-hidden="true" focusable="false">
              <use xlinkHref="#left-double-quote" />
            </svg>
          </div>
          <Html className="title-teaser__description h2 theme--white js-kinetic-animation hide-on-mobile">
            {this.props.fieldShortDescription}
          </Html>
          <h1
            className="title-teaser__title h4 h4--medium theme--white js-kinetic-animation"
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />
          <h2
            className="title-teaser__subtitle h3 h3--medium js-kinetic-animation"
            dangerouslySetInnerHTML={{ __html: this.props.fieldSubtitle }}
          />
        </div>
        <ScalableMedia className="site-content__hero site-content__screen site-content__screen--fixed site-content--bottom-gradient js-scale-media-container">
          {this.props.fieldImage}
        </ScalableMedia>
        <div className="site-content__more-info site-content__screen site-content__screen--fixed">
          <ScalableMedia className="screen screen--right screen--fixed js-scale-media-container hide-on-tablet">
            {this.props.fieldImage2}
          </ScalableMedia>
        </div>
        <div
          id="more-info"
          className="site-content__more-info site-content__screen site-content__screen--fill theme__gradient"
        >
          <div className="screen screen--left screen--padding theme__bg wysiwyg theme--white">
            <div className="mobile-title hide-on-desktop">
              <span
                className="h4 h4--medium"
                dangerouslySetInnerHTML={{ __html: this.props.title }}
              />
              <span
                className="h3 h3--medium theme--darkest-blue"
                dangerouslySetInnerHTML={{ __html: this.props.fieldSubtitle }}
              />
            </div>
            <Html>
              {this.props.body}
            </Html>
          </div>
        </div>
        <StorylinePagination />
      </main>
    );
  }
  /* eslint-enable react/no-danger */
}

export default Story;



// WEBPACK FOOTER //
// ./screens/App/screens/SplatRouter/screens/Story/component.js